import meteorMint from "@/assets/meteor-mint.png";
import meteor1 from "@/assets/meteor1.png";
import meteor2 from "@/assets/meteor2.png";
import meteor3 from "@/assets/meteor3.png";
import { useLanguage } from "@/hooks/useLanguage";
import { Badge } from "@/components/ui/badge";

const featureImages = [meteor1, meteor2, meteor3];

const MittelstandSection = () => {
  const { t, tArray } = useLanguage();
  const features = tArray('mittelstand.features');
  
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">{t('mittelstand.tag')}</Badge>
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-2">
            {t('mittelstand.title')}
          </h2>
          <p className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
            {t('mittelstand.titleLine2')}
          </p>
          <p className="text-lg text-chathero-orange font-semibold mb-12">
            {t('mittelstand.subtitle')}
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-background rounded-2xl p-8 border border-border hover:border-chathero-mint hover:shadow-lg transition-all duration-300"
              >
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <img 
                    src={featureImages[index]} 
                    alt="" 
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="text-foreground font-medium">{feature}</p>
              </div>
            ))}
          </div>

          <div className="inline-flex items-center gap-3 bg-primary text-primary-foreground rounded-full px-6 py-3 mt-12">
            <img src={meteorMint} alt="Chathero" className="w-5 h-5 object-contain" />
            <span className="font-semibold">{t('mittelstand.badge')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MittelstandSection;